import { render } from "./AuditLogsPage.vue?vue&type=template&id=57b13d52&ts=true"
import script from "./AuditLogsPage.vue?vue&type=script&lang=ts"
export * from "./AuditLogsPage.vue?vue&type=script&lang=ts"

import "./AuditLogsPage.vue?vue&type=style&index=0&id=57b13d52&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__